"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssessmentStatus = void 0;
exports.instanceOfAssessmentStatus = instanceOfAssessmentStatus;
exports.AssessmentStatusFromJSON = AssessmentStatusFromJSON;
exports.AssessmentStatusFromJSONTyped = AssessmentStatusFromJSONTyped;
exports.AssessmentStatusToJSON = AssessmentStatusToJSON;
exports.AssessmentStatusToJSONTyped = AssessmentStatusToJSONTyped;
/**
 *
 * @export
 */
exports.AssessmentStatus = {
    Pending: 'PENDING',
    Passed: 'PASSED',
    Failed: 'FAILED',
    Exhausted: 'EXHAUSTED',
    Expired: 'EXPIRED'
};
function instanceOfAssessmentStatus(value) {
    for (const key in exports.AssessmentStatus) {
        if (Object.prototype.hasOwnProperty.call(exports.AssessmentStatus, key)) {
            if (exports.AssessmentStatus[key] === value) {
                return true;
            }
        }
    }
    return false;
}
function AssessmentStatusFromJSON(json) {
    return AssessmentStatusFromJSONTyped(json, false);
}
function AssessmentStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function AssessmentStatusToJSON(value) {
    return value;
}
function AssessmentStatusToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=AssessmentStatus.js.map